// Centraliza a URL base da API usando variável de ambiente Vite.
// Em desenvolvimento: http://localhost:3001 (definido em .env)
// Em produção: usa a própria origem (protocolo+host) de onde a página foi carregada,
// já que o nginx faz proxy de /api/ para o backend tanto no IP quanto no domínio.
// Isso evita chamadas cross-origin para um host cujo certificado TLS não bate
// (ex: acessar via bmicapjota.com.br mas chamar a API via IP com cert de outro nome).
const BASE_URL = import.meta.env.VITE_API_URL || window.location.origin

export const API = {
  BASE: BASE_URL,
  AUTH: `${BASE_URL}/api/login`,
  ASSESSMENT: `${BASE_URL}/api/assessment`,
  REPORT: `${BASE_URL}/api/report`,
  ADMIN: `${BASE_URL}/api/admin`,
  FACILITADOR: `${BASE_URL}/api/facilitador`,
  IMPORTAR: `${BASE_URL}/api/importar`,
}
